import { FunnelIcon } from '@heroicons/react/20/solid';

import MissingTimesheetShiftCard from '../components/MissingTimesheetShiftCard';
import useMissingTimesheetQueue from '../hooks/useMissingTimesheetQueue';

import LoadingState from '@/components/LoadingState';

// Missing-timesheet queue: hired workers on ended shifts with no captured
// timesheet data, grouped by shift. Mirrors the No-show layout.

type Props = { agencyId: number };

const MissingTimesheetTab = ({ agencyId }: Props) => {
  const { data, isLoading, isError } = useMissingTimesheetQueue(agencyId);
  const shifts = data?.shifts ?? [];

  return (
    <div>
      <div className="dashv2-queue-title">
        <h2 className="dashv2-queue-heading">Missing timesheet</h2>
        <button type="button" className="dashv2-showbtn" disabled>
          <FunnelIcon />
          Show
        </button>
      </div>

      {isLoading && !data ? (
        <LoadingState />
      ) : isError ? (
        <div className="dashv2-queue-empty">
          Unable to load the queue. Please retry.
        </div>
      ) : shifts.length === 0 ? (
        <div className="dashv2-queue-empty">No missing timesheets. 🎉</div>
      ) : (
        <div className="dashv2-queue-list">
          {shifts.map((shift) => (
            <MissingTimesheetShiftCard key={shift.shift_id} shift={shift} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MissingTimesheetTab;
